module.exports = __webpack_public_path__ + "static/media/unique-student-identifier.ed53eb9f.jpg";